import { StyleSheet } from 'react-native';
import { tokens, useBreakpoint } from '@airtel/air-design-system';
export var generateBreakpoints = type => {
  switch (type) {
    case 'list':
      return {
        xs: {
          firstSeekGapSpacing: 20,
          lastSeekGapSpacing: 20,
          slidesPerPage: 2,
          slidesToScroll: 2,
          itemSpacing: 12,
          seekGap: 12
        },
        sm: {
          firstSeekGapSpacing: 20,
          lastSeekGapSpacing: 20,
          itemSpacing: 12,
          seekGap: 12
        },
        md: {
          firstSeekGapSpacing: 20,
          lastSeekGapSpacing: 20,
          itemSpacing: 12,
          seekGap: 12
        },
        lg: {
          firstSeekGapSpacing: 20,
          lastSeekGapSpacing: 20,
          itemSpacing: 12,
          seekGap: 12
        },
        xl: {
          firstSeekGapSpacing: 20,
          lastSeekGapSpacing: 20,
          itemSpacing: 12,
          seekGap: 12
        }
      };
    case 'inventoryBanner':
      return {
        xs: {
          slidesPerPage: 1
        },
        sm: {
          slidesPerPage: 1
        },
        md: {
          slidesPerPage: 1
        },
        lg: {
          slidesPerPage: 1
        },
        xl: {
          slidesPerPage: 1
        }
      };
  }
};
export var getDefaultAspectRatio = (type, size) => {
  switch (type) {
    case 'list':
      return 0.67;
    case 'inventoryBanner':
      {
        var defaultAspectRatio = {
          md: 2.79,
          sm: 4.19,
          xs: 8.38
        };
        return defaultAspectRatio[size];
      }
  }
};
export var getGrowthInventoryWidgetStyles = props => {
  var carouselWidgetProps = props.carouselWidgetProps,
    aspectRatio = props.aspectRatio,
    useSizeScaling = props.useSizeScaling;
  var _ref = carouselWidgetProps !== null && carouselWidgetProps !== void 0 ? carouselWidgetProps : {},
    _ref$heightConfig = _ref.heightConfig,
    heightConfig = _ref$heightConfig === void 0 ? {
      desktop: 230,
      mobile: 200
    } : _ref$heightConfig;
  var _useBreakpoint = useBreakpoint({
      returnAsObject: true
    }),
    isLargeScreen = _useBreakpoint.isLargeScreen;
  return StyleSheet.create({
    cardContainerOuter: {
      position: 'relative'
    },
    cardContainer: {},
    imageContainer: Object.assign({
      borderRadius: (props === null || props === void 0 ? void 0 : props.type) === 'inventoryBanner' && (props === null || props === void 0 ? void 0 : props.size) === 'xs' ? tokens.borderRadius.BORDER_RADIUS_8 : tokens.borderRadius.BORDER_RADIUS_16
    }, useSizeScaling ? {} : Object.assign({
      width: '100%',
      flexShrink: 0
    }, aspectRatio ? {
      aspectRatio
    } : heightConfig && {
      minHeight: isLargeScreen ? heightConfig === null || heightConfig === void 0 ? void 0 : heightConfig.desktop : heightConfig === null || heightConfig === void 0 ? void 0 : heightConfig.mobile
    })),
    sectionTital: {
      marginBottom: tokens.spacing.SPACING_12,
      paddingRight: tokens.spacing.SPACING_20
    },
    imageSkeleton: {
      position: 'absolute'
    }
  });
};